module.exports = __webpack_public_path__ + "static/media/coin.019345cd.svg";